module.exports = __webpack_public_path__ + "static/laptop-20aa297e1d8364d1acc7aebacef75005.png";